module.exports = {"user":"chants","services":["https://db.r-mes.ovh/carnet/_design/argos/_rewrite"],"reservedViewpoints":["U01 - Indications du Père Jacques Breton"],"customization":{"chants":{"listView":{"mode":"song"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = 6
// module chunks = 0